<template>
  <ul-page class="page-term-manager">
    <template v-slot:left>
      <div class="page-header-left">
        <div class="page-header-title">版本与学期管理</div>
      </div>
    </template>
    <div class="page-content">
      <div class="back-wrapper">
        <div class="back" @click="$router.back()">
          <i class="iconfont icon-shangyige"></i><span>返回</span>
        </div>
      </div>
      <div class="course-title">{{course.name}}</div>
      <div class="course-url">课程门户：<a :href="textbookPortalUrl" target="_blank">{{textbookPortalUrl}}</a></div>
      <ul-table class="table-course" border :data="[course]">
        <ul-table-column
          prop="name"
          label="累计选课人数"
          >
          <template slot-scope="scope">
            <div class="col-total">
              <div class="">总数：{{scope.row.totalLearnerCount}}</div>
              <div class="">本校：{{scope.row.insideLearnerCount}}</div>
              <div class="">其他高校：{{scope.row.outsideLearnerCount}}</div>
              <div class="">社会学习者：{{scope.row.socialLearnerCount}}</div>
            </div>
          </template>
        </ul-table-column>
        <ul-table-column
          prop="name"
          label="选课学校总数"
          width="200px"
          >
          <template slot-scope="scope">
            <div class="school-num">
              <div>{{scope.row.spocOrgCount}}</div>
              <a href="javascript:;" @click="viewSchoolData">查看详情</a>
            </div>
          </template>
        </ul-table-column>
        <ul-table-column
          prop="outsideSpocCount"
          label="外校SPOC总数"
          width="200px"
          >
        </ul-table-column>
      </ul-table>
      <div class="portal-tips">*数据每天更新一次</div>
      <div class="section section-version">
        <div class="section-header">
          <div class="section-title">课件版本</div>
          <ul-button hollow @click="toTextbookLib">课件库</ul-button>
          <ul-button type="primary" @click="addNewVersion">关联新版本</ul-button>
        </div>
        <div class="section-tips">
          课件如果有大的版本更新，为避免影响往期学生成绩，请在课件库中复制新的版本再更新。创建新版本后，需手动将新版本关联到当前课程，新版本的选课数据才能计入当前课程。
        </div>
        <ul-table class="table-version" border :data="versionList">
        <ul-table-column
          label="版本"
          prop="index"
          width="80px"
          >
        </ul-table-column>
        <ul-table-column
          prop="courseId"
          label="ID"
          width="120px"
          >
        </ul-table-column>
        <ul-table-column
          prop="courseName"
          label="名称"
          >
        </ul-table-column>
        <ul-table-column
          label="创建时间"
          width="200px"
          >
          <template  slot-scope="scope">
            <span>{{scope.row.createTime | formatDate}}</span>
          </template>
        </ul-table-column>
        <ul-table-column
          label="最近更新时间"
          width="200px"
          >
          <template  slot-scope="scope">
            <span>{{scope.row.updateTime | formatDate}}</span>
          </template>
        </ul-table-column>
        <ul-table-column
          label="操作"
          width="120px"
          >
          <template  slot-scope="scope">
            <span v-if="scope.row.isOriginCourse">-</span>
            <a href="javascript:;" v-else @click="deleteVersion(scope.row)">取消关联</a>
          </template>
        </ul-table-column>
      </ul-table>
      </div>
      <div class="section section-term">
        <div class="section-header">
          <div class="section-title">开课学期</div>
          <ul-button type="primary" @click="addNewTerm">添加学期</ul-button>
        </div>
        <div class="section-tips">
          课程如果分期开课，每学期请创建新的班课，然后在这里添加学期，并关联对应的班课。设置好以后，即可在这里查看每一期的运行数据。
        </div>
        <ul-table class="table-version" border :data="termList">
          <ul-table-column
            label="期数"
            width="80px"
            >
            <template  slot-scope="scope">
              <span>{{termList.length - scope.$index}}</span>
            </template>
          </ul-table-column>
          <ul-table-column
            prop="time"
            label="开课时间"
            width="300px"
            >
            <template  slot-scope="scope">
              <span>{{getTermTime(scope.row)}}</span>
              <!-- <span>{{scope.row.startTime | formatDate}}</span> -->
            </template>
          </ul-table-column>
          <ul-table-column
            prop="courseName"
            label="状态"
            >
            <template slot-scope="scope">
            {{termStatusMap[scope.row.status]}}
            </template>
          </ul-table-column>
          <ul-table-column
            prop="studentNum"
            label="选课人数"
            width="150px"
            >
          </ul-table-column>
          <ul-table-column
            label="操作"
            width="250px"
            >
            <template  slot-scope="scope">
              <a class="btn-link" href="javascript:;" @click="showTermData(scope.row, termList.length - scope.$index)">数据统计</a>
              <a class="btn-link" href="javascript:;" @click="modifyTerm(scope.row)">修改</a>
              <a class="btn-link" href="javascript:;" @click="deleteTerm(scope.row)">删除</a>
              <a class="btn-link" href="javascript:;" @click="enterClass(scope.row)">进入班课</a>
            </template>
          </ul-table-column>
        </ul-table>
      </div>
      <div class="learner-count">
        自主学习人数（未加入任何学期，自主选课学习的学生人数）：{{ course.selfLearnerCount || 0 }}
      </div>
    </div>
    <!-- <ul-dialog
      title="关联新版本"
      class="dialog-version"
      width="800px"
      @open="getOriginTextbookList"
      :visible.sync="versionDialogVisiable">
      <div class="textbook-area">
        <ul-input
          class="search-group"
          placeholder="输入关键词搜索"
          clearable
          suffix-icon="icon-quanshipei-sousuo"
          search
          @search="getOriginTextbookList"
          @keydown.native.enter="getOriginTextbookList"
          v-model="originKeyword">
        </ul-input>
        <ul class="origin-textbooks-list">
          <li v-for="(item,index) in originTextbookList" :key="index">
            <ul-checkbox v-model="versionIds" :label="item.courseId" :disabled="item.allowfreedomreg != 1 || !!item.declareCourseId">
              <div class="radio-content">
                <span class="title">{{item.name}}</span>
                <span class="status" v-if="item.allowfreedomreg == 1">（ID：{{item.courseId}},创建时间：{{item.createTime | formatDate}}）</span>
                <span class="status" v-if="item.allowfreedomreg == 0">（未发布）</span>
              </div>
            </ul-checkbox>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <ul-button type="primary" @click="submitNewVersion">确 定</ul-button>
        <ul-button plain @click="versionDialogVisiable = false">取 消</ul-button>
      </span>
    </ul-dialog> -->
    <ul-dialog
      title="关联新版本"
      class="dialog-version"
      width="800px"
      @open="getOriginTextbookList"
      :visible.sync="versionDialogVisiable">
      <div class="textbook-area">
        <ul-input
          class="search-group"
          placeholder="输入关键词搜索"
          clearable
          suffix-icon="icon-quanshipei-sousuo"
          search
          @search="getOriginTextbookList"
          @keydown.native.enter="getOriginTextbookList"
          v-model="originKeyword">
        </ul-input>
        <ul class="origin-textbooks-list">
          <li v-for="(item,index) in originTextbookList" :key="index">
            <ul-checkbox v-model="versionIds" :label="item.courseId" :disabled="item.allowfreedomreg != 1 || !!item.declareCourseId">
              <div class="radio-content">
                <span class="title">{{item.name}}</span>
                <span class="status" v-if="item.allowfreedomreg == 1">（ID：{{item.courseId}},创建时间：{{item.createTime | formatDate}}）</span>
                <span class="status" v-if="item.allowfreedomreg == 0">（未发布）</span>
              </div>
            </ul-checkbox>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <ul-button type="primary" @click="submitNewVersion">确 定</ul-button>
        <ul-button plain @click="versionDialogVisiable = false">取 消</ul-button>
      </span>
    </ul-dialog>
    <ul-dialog
      title="添加学期"
      class="dialog-term"
      width="800px"
      @opened="dialogTermOpened"
      @open="getOcList"
      :visible.sync="termDialogVisiable">
      <ul-form ref="termForm" :model="term" :rules="rules" label-width="auto">
        <ul-form-item prop="time" class="form-item-time" label="开课时间">
          <ul-date-picker type="date" format="yyyy-MM-dd" value-format="timestamp" v-model="term.startTime" placeholder="开始时间"></ul-date-picker>
          <span class="split">至</span>
          <ul-date-picker type="date" format="yyyy-MM-dd" value-format="timestamp" v-model="term.endTime" placeholder="结束时间"></ul-date-picker>
        </ul-form-item>
        <ul-form-item prop="textbookId" label="课件版本">
          <ul-select v-model="term.textbookId" placeholder="请选择课件版本">
            <ul-option v-for="item in versionList" :key="item.id" :value="item.courseId" :label="item.courseName"></ul-option>
          </ul-select>
        </ul-form-item>
        <ul-form-item prop="ocIds" label="关联班课" class="form-item-origin">
          <div class="tips">请选择关联的随堂班课，每个班课只能关联一个学期。</div>
          <div class="select-resource-div">
            <dl>
              <dd @click="selectType(1)" :class="{'select-dd':activeName==1}">本校班课</dd>
              <dd @click="selectType(2)" :class="{'select-dd':activeName==2}">外校班课</dd>
            </dl>
          </div>
          <ul-checkbox-group v-model="term.ocIds">
            <ul-table class="table-course" border :data="termOcList">
              <ul-table-column
                prop="name"
                label="名称"
                >
                <template slot-scope="scope">
                  <ul-checkbox :label="scope.row.ocId" :disabled="!!scope.row.associated && term.id != scope.row.associated">
                    <span>{{scope.row.ocName}}</span>
                  </ul-checkbox>
                </template>
              </ul-table-column>
              <ul-table-column
                v-if="activeName == 2"
                prop="orgName"
                label="开设院校"
                width="160px"
                >
              </ul-table-column>
              <ul-table-column
                prop="teacherName"
                label="创建人"
                width="100px"
                >
              </ul-table-column>
              <ul-table-column
                prop="userCount"
                label="学生人数"
                width="100px"
                >
              </ul-table-column>
              <ul-table-column
                prop="createTime"
                label="创建时间"
                width="160px"
                >
                <template slot-scope="scope">
                  <span>{{scope.row.createTime | formatDate}}</span>
                </template>
              </ul-table-column>
            </ul-table>
          </ul-checkbox-group>
        </ul-form-item>
      </ul-form>
      <span slot="footer" class="dialog-footer">
        <ul-button type="primary" @click="submitTerm">确 定</ul-button>
        <ul-button plain @click="termDialogVisiable = false">取 消</ul-button>
      </span>
    </ul-dialog>
    <ul-dialog
      :title="`第${currentStatTermNum}期`"
      class="dialog-term-data"
      width="800px"
      :visible.sync="termDataDialogVisiable">
     <ul>
      <li>
        <div class="data-label">课件视频</div>
        <div class="data-content">
          <div class="data-item">总数量：{{termStat.videoCount}}个</div>
          <div class="data-item">总时长：{{termStat.videoLength}}分钟</div>
        </div>
      </li>
      <li>
        <div class="data-label">非视频资源</div>
        <div class="data-content">
          <div class="data-item">课件中的图文页面数量：{{termStat.graphicPageCount}}个</div>
          <div class="data-item">课件中的非视频资源数量：{{termStat.notVideoResourceCount}}个</div>
          <div class="data-item">班课中的拓展资源数量：{{termStat.ocContentCount}}个</div>
        </div>
      </li>
      <li>
        <div class="data-label">课程公告</div>
        <div class="data-content">
          <div class="data-item">数量：{{termStat.announcementCount}}次</div>
        </div>
      </li>
      <li>
        <div class="data-label">作业/测验</div>
        <div class="data-content">
          <div class="data-item">总次数：{{termStat.homeworkCount}}次</div>
          <div class="data-item">试题数量：{{termStat.homeworkQuestionCount}}道（仅【测验】类型作业包含试题）</div>
          <div class="data-item">参与人数：{{termStat.homeworkLearnerCount}}人</div>
        </div>
      </li>
      <li>
        <div class="data-label">讨论交流</div>
        <div class="data-content">
          <div class="data-item">帖子总数：{{termStat.discussionCount}}个</div>
          <div class="data-item">教师发帖/回复总数：{{termStat.discussionTeacherActionCount}}次</div>
          <div class="data-item">参与讨论人数：{{termStat.discussionJoinerCount}}人</div>
          <div class="data-item">总发帖回帖数：{{termStat.discussionPostCount}}次</div>
        </div>
      </li>
      <li>
        <div class="data-label">考试</div>
        <div class="data-content">
          <div class="data-item">考试次数：{{termStat.examCount}}次</div>
          <div class="data-item">考试题数：{{termStat.examQuestionCount}}道</div>
          <div class="data-item">参与人数：{{termStat.examJoinerCount}}人</div>
          <div class="data-item">通过人数：{{termStat.examPassCount}}人</div>
        </div>
      </li>
     </ul>
     <div class="tips">* 数据每日凌晨更新</div>
    </ul-dialog>
    <ul-dialog
      title="选课学校"
      class="dialog-school-data"
      width="800px"
      :visible.sync="schoolDataDialogVisiable">
        <div class="total-num">总数：{{course.spocOrgCount}}</div>
        <ul-table class="table-course" border :data="course.spocOrgList">
          <ul-table-column
            prop="orgName"
            label="学校">
          </ul-table-column>
          <ul-table-column
            prop="spocCount"
            label="开设SPOC数量"
            width="200px"
            >
          </ul-table-column>
          <ul-table-column
            prop="studentCount"
            width="150px"
            label="参与人数">
          </ul-table-column>
        </ul-table>
      </ul-dialog>
  </ul-page>
</template>

<script>
import { getDeclareCourseInfo,
         getDeclareCourseVersion,
         getDeclareCourseTerm,
         getDeclareOriginTextbookList,
         addDeclareCourseVersion,
         deleteDeclareCourseVersion,
         getDeclareCourseOcList,
         saveDeclareCourseTerm,
         deleteDeclareCourseTerm,
         getDeclareCourseTermStat,
         getCourseMenu,
         getCourseOcListOtherOrg
        } from '@/api/courseApi'
import formateDate from '@/mixins/formatDate.js'
import { formatDate } from '@/utils'
import { COURSE_WEB_HOST, UA_WEB_HOST, UMOOC_SERVER_HOST } from '@/config'
export default {
  name: 'page-term-manager',
  mixins: [formateDate],
  data () {
    return {
      course: {},
      versionList: [],
      termList: [],
      versionDialogVisiable: false,
      originKeyword: '',
      originTextbookList: [],
      versionIds: [],
      term: { ocIds: [] },
      termDialogVisiable: false,
      termOcList: [],
      formatDate: formatDate,
      termStatusMap: {
        '1': '未开始',
        '2': '进行中',
        '3': '已结束'
      },
      termDataDialogVisiable: false,
      termStat: {},
      currentStatTermNum: '',
      schoolDataDialogVisiable: false,
      activeName: 1
    }
  },
  computed:{
    courseId () {
      return this.$route.query.courseId
    },
    rules () {
      let rules = {
        time: [ 
          // {
          //   required: true, message: '请选择开始时间', trigger: 'blur'
          // },
          { validator: (rule, value, callback) => {
            if (!this.term.startTime) {
              return callback(new Error('请选择开始时间'));
            }
            if (!this.term.endTime) {
              return callback(new Error('请选择结束时间'));
            }
            if (this.term.endTime < this.term.startTime) {
              return callback(new Error('结束时间不能早于开始时间'));
            }
            callback();
          }, trigger: 'change' }
        ],
        textbookId: [
          { required: true, message: '请选择课件版本', trigger: 'change' }
        ],
        ocIds: [
          { required: true, message: '请选择关联班课', trigger: 'change' }
        ]
      }
      return rules
    },
    textbookPortalUrl () {
      return `${UMOOC_SERVER_HOST}/course/${this.course.courseId}`
    }
  },
  created () {
    window.test = this
    this.getDeclareCourseInfo()
    this.getDeclareCourseVersion()
    this.getDeclareCourseTerm()
  },
  methods: {
    selectType (type) {
      this.activeName = type
      if (type == 1) {
        this.getOcList()
      } else {
        this.otherClass()
      }
    },
    otherClass () {
      getCourseOcListOtherOrg(this.courseId)
      .then(({result}) => {
        this.termOcList = result
        console.log(result)
      })
    },
    enterClass (row) {
      this.term = {...this.term, ...row}
      getDeclareCourseOcList(this.courseId)
      .then(({result}) => {
        let list = []
        result.forEach(item => {
          if (this.term.id == item.associated && this.term.ocIds.indexOf(item.ocId) != -1) {
            list.push(item)
          }
        })
        getCourseOcListOtherOrg(this.courseId)
        .then(({result}) => {
          result.forEach(item => {
            if (this.term.id == item.associated && this.term.ocIds.indexOf(item.ocId) != -1) {
              list.push(item)
            }
          })
          let ocId = null
          if (list.length == 1) {
            ocId = list[0].ocId
          } else if (list.length > 1) {
            let data = this.getMax(list)
            ocId = data.ocId
          }

          if (ocId) {
            getCourseMenu(ocId)
            .then(({result}) => {
              console.log(result)
              let hash = ''
              let menuId = 1
              let arr = result.filter(item => item.isHomepage)
              if (arr.length > 0) {
                menuId = arr[0].id
              }
              switch (menuId) {
                case 1:
                  hash = 'announcement'
                  break;
                case 2:
                  hash = 'textbook'
                  break;
                case 3:
                  hash = 'resource'
                  break;
                case 4:
                  hash = 'homework'
                  break;
                case 5:
                  hash = 'discussion'
                  break;
                case 6:
                  hash = 'classroom'
                  break;
                case 7:
                  hash = 'live'
                  break;
                case 8:
                  hash = 'exam'
                  break;
                case 18:
                  hash = 'units'
                  break;
                case 19:
                  hash = 'knowledgeGraph'
                  break;
                default:
                  hash = 'announcement'
              }
              window.open(`${COURSE_WEB_HOST}/ulearning/index.html#/course/${hash}?courseId=${ocId}`)
            })
          }
        })
      })
    },
    getMax(data) {
      let max = data[0];
      for (let i = 1; i < data.length; i++){
        if (data[i].userCount > max.userCount) {
          max = data[i];
        }
      }
      return max;
    },
    getDeclareCourseInfo () {
      getDeclareCourseInfo(this.courseId)
        .then(({result}) => {
          this.course = result
          // this.course.spocOrgList = [
          //   {
          //     orgName: '武汉工程大学',
          //     spocCount: 12,
          //     studentCount: 22
          //   },
          //   {
          //     orgName: '武汉工程大学',
          //     spocCount: 12,
          //     studentCount: 22
          //   },
          //   {
          //     orgName: '武汉工程大学',
          //     spocCount: 12,
          //     studentCount: 22
          //   }
          // ]
        })
    },
    getDeclareCourseVersion () {
      getDeclareCourseVersion(this.courseId)
        .then(({result}) => {
            this.versionList = result.map((item, index) => {
              item.index = index + 1
              return item
            })
            this.versionList = this.versionList.reverse()
            this.versionIds = this.versionList.map(item => item.courseId)
        })
    },
    getDeclareCourseTerm () {
      getDeclareCourseTerm(this.courseId)
        .then(({result}) => {
            this.termList = result.map(item => {
              item.textbookId = item.textbookId || ''
              return item
            })
        })
    },
    getOriginTextbookList () {
      getDeclareOriginTextbookList({ courseName: this.originKeyword })
        .then(({result}) => {
          this.originTextbookList = result
        })
    },
    addNewVersion () {
      this.versionDialogVisiable = true
    },
    submitNewVersion () {
      if (this.versionIds.length == 0) {
        return this.$message({
          message: '请至少选择一个版本',
          type: 'warning'
        })
      }
      addDeclareCourseVersion({
        declareCourseId: this.courseId,
        courseIds: this.versionIds
      })
        .then(({result}) => {
          this.versionDialogVisiable = false
          this.getDeclareCourseVersion()
        })
    },
    deleteVersion (item) {
      this.$confirm('确定取消关联吗？','取消关联')
        .then(() => {
          deleteDeclareCourseVersion(item.id)
            .then(() => {
              this.$message({
                message: '取消成功',
                type: 'success'
              })
              this.getDeclareCourseVersion()
            })
        })
    },
    getTermTime (item) {
      return formatDate(item.startTime, 'yyyy-MM-dd') + ' 至 ' + formatDate(item.endTime, 'yyyy-MM-dd')
    },
    addNewTerm () {
      this.term = { ocIds: [],textbookId: this.versionList[0].courseId }
      // this.term.textbookId = this.versionList[0].courseId
      this.termDialogVisiable = true
    },
    dialogTermOpened () {
      this.$refs['termForm'].clearValidate()
    },
    getOcList () {
      this.activeName = 1
      getDeclareCourseOcList(this.courseId)
        .then(({result}) => {
          console.log(result)
          this.termOcList = result
        })
    },
    submitTerm () {
      this.$refs['termForm'].validate(valid => {
        if (valid) {
         console.log(this.term)
         this.term.declareCourseId = this.courseId
         saveDeclareCourseTerm(this.term)
          .then(({result}) => {
            this.termDialogVisiable = false
            this.getDeclareCourseTerm()
          })
        }
      })
    },
    showTermData (item, num) {
      this.termDataDialogVisiable = true
      this.currentStatTermNum = num
      getDeclareCourseTermStat(item.id)
        .then(({result}) => {
          console.log(result)
          result.videoLength = Math.round(result.videoLength * 10 / 60) / 10
          this.termStat = result
        })
    },
    modifyTerm (item) {
      // item.ocIds = [34502]
      this.term = {...this.term, ...item}
      this.termDialogVisiable = true
    },
    deleteTerm (item) {
      this.$confirm('确定删除吗？', '删除学期')
        .then(() => {
          deleteDeclareCourseTerm(item.id)
            .then(({result}) => {
              this.getDeclareCourseTerm()
            })
        })
    },
    viewSchoolData () {
      this.schoolDataDialogVisiable = true
    },
    toTextbookLib () {
      window.open(`${UA_WEB_HOST}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content{
  padding: 20px;
   .back-wrapper{
    display: flex;
    align-items: center;
    margin-bottom: 6px;
   }
   .back {
    cursor: pointer;
    line-height: 20px;
    i{
      margin-right: 6px;
      color: #cbcbd1;
    }
    &:hover{
      span{
        color: $--color-primary;
      }
    }
  }
  .course-title{
    font-size: 20px;
    font-weight: bold;
  }
  .course-url{
    color: $--color-text-secondary;
  }
  .table-course{
    margin-top: 10px;
  }
  .portal-tips{
    margin-top: 8px;
    color: $--color-primary;
    font-size: 12px;
  }
  .section{
    margin-top: 20px;
    .section-header{
      display: flex;
      align-items: center;
    }
    .section-title{
      flex: 1;
      margin-right: 10px;
      padding: 0px 8px;
      border-left: solid 3px $--color-primary;
      line-height: 1;
      font-size: 16px;
      font-weight: bold;
    }
    .section-tips{
      padding: 8px;
      border-radius: 2px;
      font-size: 12px;
      color: #ce9d2b;
    }
  }
  .section-term{
    .btn-link{
      margin-right: 10px;
    }
  }
  
}
.learner-count {
  // margin-top: 20px;
  padding: 15px 10px;
  border: 1px solid #e3e3e9;
  border-top: none;
}
.dialog-version{
  .search-group {
    width: 300px;
  }
  .ul-checkbox{
    line-height: 36px;
  }
  .origin-textbooks-list{
    min-height: 240px;
    max-height: 360px;
    margin-top: 6px;
    overflow: auto;
  }
  .radio-content{
    display: inline-block;
  }
}
.dialog-term{
  .select-resource-div {
    margin: 0;
    margin-bottom: 16px;
    color: #444;
    font-size: 14px;
    .select-dd {
      color: #ea5947;
      border-bottom: 2px solid #ea5947;
    }
    dl {
      display: flex;
      width: 100%;
      border-bottom: 1px solid rgba($color: #000000, $alpha: 0.2);
      dd {
        padding: 5px 10px;
        cursor: pointer;
      }
    }
    dl,
    dd {
      margin: 0;
    }
  }
  .split{
    margin: 0 10px;
  }
  .form-item-time{
    ::v-deep {
      .ul-form-item__label{
        &:before{
          content: '*';
          color: #f60000;
          margin-right: 4px;
        }
      }
    }
  }
}
.dialog-term-data{
  ul{
    border: $--border-base;
    li{
      display: flex;
      align-items: center;
      line-height: 24px;
      &:not(:last-child){
        border-bottom: $--border-base;
      }
      .data-label{
        width: 120px;
        padding: 10px 10px;
        
      }
      .data-content{
        width: 0;
        flex: 1;
        padding: 10px 10px;
        border-left: $--border-base;
      }
    }
  }
  .tips{
    color: $--color-primary;
    line-height: 40px;
  }
}
.dialog-school-data{
  .total-num{
    font-weight: bold;
  }
  .ul-table{
    margin: 10px 0;
  }
}
</style>